import React from "react";
import ContactMenu from "./ContactMenu";
import './Contact.css';

const Contact = () => {
  return <ContactMenu />;
};

export default Contact;
